import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PreRegistrationService } from '@common/services/pre-registration/pre-registration.service';
import { ROUTE_PATHS } from '@common/utils/route-paths.const';

/**
 * Allows the pre-registration confirmation page only after a successful submission
 * (a reference number is present). On direct URL access or a browser refresh the
 * flow state is gone, so the applicant is redirected back to the start of the flow.
 */
export const preRegistrationDoneGuard: CanActivateFn = ():
  boolean | UrlTree => {
  const router = inject(Router);
  const preRegistrationService = inject(PreRegistrationService);

  if (preRegistrationService.referenceNumber()) {
    return true;
  }

  return router.createUrlTree([ROUTE_PATHS.PRE_REGISTRATION]);
};
